import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { select } from '../commands/SelectionCommands';
import { EditorOptions } from '../EditorOptions';

export class ReplayCustomMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch: CommandDispatcher;
    @resolve(ObjectManager) private objects: ObjectManager;
    @resolve(EditorOptions) private options: EditorOptions;

    public start(): void {
        this.burden(
            this.objects.createInterceptor('DisableLocking')
                .forAllTypes()
                .on('locked', {
                    get: (_elmt) => false,
                    set: (_elmt, _value) => { }
                })
        );

        if (this.options.elementId) {
            this.dispatch(select, [this.options.elementId]);
        }
    }
}

